export default {
  national: {
    fr: '/',
    en: '/',
    ja: '/',
  },
  nationalPublications: {
    tabs: [
      {
        fr: '/publications/general',
        en: '/publications/general',
        ja: '/publications/general',
      },
      {
        fr: '/publications/disciplines',
        en: '/publications/fields',
        ja: '/publications/fields',
      },
      {
        fr: '/publications/editeurs',
        en: '/publications/publishers',
        ja: '/publications/publishers',
      },
      {
        fr: '/publications/archives',
        en: '/publications/repositories',
        ja: '/publications/repositories',
      },
      {
        fr: '/publications/financements',
        en: '/publications/fundings',
        ja: '/publications/fundings',
      },
      {
        fr: '/publications/a-decider',
        en: '/publications/to-be-decided',
        ja: '/publications/to-be-decided',
      },
    ],
    fr: '/publications',
    en: '/publications',
    ja: '/publications',
  },
  nationalResearchData: {
    tabs: [
      {
        fr: '/donnees-de-la-recherche/general',
        en: '/research-data/general',
        ja: '/research-data/general',
      },
      {
        fr: '/donnees-de-la-recherche/disciplines',
        en: '/research-data/fields',
        ja: '/research-data/fields',
      },
      {
        fr: '/donnees-de-la-recherche/editeurs',
        en: '/research-data/publishers',
        ja: '/research-data/publishers',
      },
    ],
    fr: '/donnees-de-la-recherche/general',
    en: '/research-data/general',
    ja: '/research-data/general',
  },
  nationalSoftwareCode: {
    tabs: [
      {
        fr: '/codes-et-logiciels/general',
        en: '/software/general',
        ja: '/software/general',
      },
      {
        fr: '/codes-et-logiciels/disciplines',
        en: '/software/fields',
        ja: '/software/fields',
      },
      {
        fr: '/codes-et-logiciels/oa',
        en: '/software/oa',
        ja: '/software/oa',
      },
    ],
    fr: '/codes-et-logiciels/general',
    en: '/software/general',
    ja: '/software/general',
  },
  nationalDataCode: {
    fr: '/data-code',
    en: '/data-code',
    ja: '/data-code',
  },
  nationalThesis: {
    tabs: [
      {
        fr: '/theses-de-doctorat/general',
        en: '/thesis/general',
        ja: '/thesis/general',
      },
    ],
    fr: '/theses-de-doctorat/general',
    en: '/thesis/general',
    ja: '/thesis/general',
  },
  nationalOrcid: {
    tabs: [
      {
        fr: '/orcid/general',
        en: '/orcid/general',
        ja: '/orcid/general',
      },
      {
        fr: '/orcid/referentiels',
        en: '/orcid/referentiels',
        ja: '/orcid/referentiels',
      },
    ],
    fr: '/orcid/general',
    en: '/orcid/general',
    ja: '/orcid/general',
  },
  sante: {
    fr: '/sante',
    en: '/health',
    ja: '/health',
  },
  santeEssais: {
    tabs: [
      {
        fr: '/sante/essais-cliniques/general',
        en: '/health/clinical-trials/general',
        ja: '/health/clinical-trials/general',
      },
      {
        fr: '/sante/essais-cliniques/caracteristiques',
        en: '/health/clinical-trials/characteristics',
        ja: '/health/clinical-trials/characteristics',
      },
      {
        fr: '/sante/essais-cliniques/promoteurs',
        en: '/health/clinical-trials/lead-sponsors',
        ja: '/health/clinical-trials/lead-sponsors',
      },
      {
        fr: '/sante/essais-cliniques/resultats',
        en: '/health/clinical-trials/results',
        ja: '/health/clinical-trials/results',
      },
    ],
    fr: '/sante/essais-cliniques/general',
    en: '/health/clinical-trials/general',
    ja: '/health/clinical-trials/general',
  },
  santeEtudes: {
    tabs: [
      {
        fr: '/sante/etudes-observationnelles/general',
        en: '/health/observational-studies/general',
        ja: '/health/observational-studies/general',
      },
      {
        fr: '/sante/etudes-observationnelles/caracteristiques',
        en: '/health/observational-studies/characteristics',
        ja: '/health/observational-studies/characteristics',
      },
      {
        fr: '/sante/etudes-observationnelles/promoteurs',
        en: '/health/observational-studies/lead-sponsors',
        ja: '/health/observational-studies/lead-sponsors',
      },
      {
        fr: '/sante/etudes-observationnelles/resultats',
        en: '/health/observational-studies/results',
        ja: '/health/observational-studies/results',
      },
    ],
    fr: '/sante/etudes-observationnelles/general',
    en: '/health/observational-studies/general',
    ja: '/health/observational-studies/general',
  },
  about: {
    fr: '/a-propos',
    en: '/about',
    ja: '/about',
  },
  methodologie: {
    fr: '/a-propos/methodologie',
    en: '/about/methodology',
    ja: '/about/methodology',
  },
  faq: {
    fr: '/a-propos/faq',
    en: '/about/faq',
    ja: '/about/faq',
  },
  glossaire: {
    fr: '/a-propos/glossaire',
    en: '/about/glossary',
    ja: '/about/glossary',
  },
  communication: {
    fr: '/a-propos/communication',
    en: '/about/communication',
    ja: '/about/communication',
  },
  variations: {
    fr: '/declinaisons/bso-locaux',
    en: '/declinaisons/bso-locaux',
    ja: '/declinaisons/bso-locaux',
  },
  howto: {
    fr: '/declinaisons/comment-realiser-bso-local',
    en: '/declinaisons/howto',
    ja: '/declinaisons/howto',
  },
  policy: {
    fr: '/declinaisons/politique-etablissements',
    en: '/declinaisons/institutional-policy',
    ja: '/declinaisons/institutional-policy',
  },
  project: {
    fr: '/projet-et-equipe',
    en: '/project-and-team',
    ja: '/project-and-team',
  },
  citation: {
    fr: '/citation',
    en: '/citation',
    ja: '/citation',
  },
  opendata: {
    fr: '/a-propos/opendata',
    en: '/about/opendata',
    ja: '/about/opendata',
  },
  worksmagnet: {
    fr: '/a-propos/works-magnet',
    en: '/about/works-magnet',
    ja: '/about/works-magnet',
  },
  integration: {
    fr: [
      '/integration/:language/:graphId/:domain/:studyType',
      '/integration/:language/:graphId/:domain',
      '/integration/:language/:graphId',
    ],
    en: [
      '/integration/:language/:graphId/:domain/:studyType',
      '/integration/:language/:graphId/:domain',
      '/integration/:language/:graphId',
    ],
    ja: [
      '/integration/:language/:graphId/:domain/:studyType',
      '/integration/:language/:graphId/:domain',
      '/integration/:language/:graphId',
    ],
  },
};
